// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/drop_arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/check.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-size: 18px;
    font-family: "Nunito Sans", sans-serif;
    color: #33345E;
}

* {
    box-sizing: border-box;
    margin: 0px;
    padding: 0px;
}

.primary_bg {
    background: #1253A7;
}

.secondary_bg {
    background: #6A79FF;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-weight: 500;
    margin-bottom: 20px;
    line-height: normal;
}

h1 {
    font-size: 50px;
    font-weight: 700;
}

h2 {
    font-size: 40px;
    font-weight: 700;
}

h3 {
    font-size: 30px;
    font-weight: 700;
}

h4 {
    font-size: 26px;
}

h5 {
    font-size: 20px;
}

p {
    margin-bottom: 20px;
}

a {
    transition: 0.4s;
}

.container {
    margin-left: auto;
    margin-right: auto;
    padding-left: 25px;
    padding-right: 25px;
    max-width: 1500px;
}

/* Distinguished Features */
.dis-features-section {
    background-position: left bottom, right top;
}

section {
    padding-top: 80px;
    padding-bottom: 80px;
}

select {
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right 15px center;
    background-repeat: no-repeat;
    background-size: 13px;
    padding-right: 35px !important;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
    display: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.list {
    margin-bottom: 25px;
}

.list li {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: 20px;
    padding-left: 28px;
    margin-bottom: 12px;
    background-position: left 2px;
}

input[type=number] {
    -moz-appearance: textfield;
}

@keyframes slide {
    from {
        background-position: 0 0;
    }

    to {
        background-position: 1920px 0;
    }
}

.heading_title {
    max-width: 800px;
    margin: auto;
    margin-bottom: 50px;
    text-align: center;
}

.businesses:nth-child(1) {
    background-color: #e43d34;
}

.businesses:nth-child(2) {
    background-color: #ff8071;
}

.businesses:nth-child(3) {
    background-color: #f19e3e;
}

.businesses:nth-child(4) {
    background-color: #f5d417;
}

.businesses:nth-child(5) {
    background-color: #4ca12c;
}

.businesses:nth-child(6) {
    background-color: #00916a;
}

.businesses:nth-child(7) {
    background-color: #007d93;
}

.businesses:nth-child(8) {
    background-color: #2362cb;
}

.businesses:nth-child(9) {
    background-color: #263294;
}

.businesses:nth-child(10) {
    background-color: #2b2261;
}

@keyframes unlimitedrotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}


.dance3 {
    animation: dance3 8s alternate infinite;
}

@keyframes dance3 {
    0% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}

/* button css */
.th-btn:before,
.th-btn:after {
    content: "";
    position: absolute;
    background-color: #1036de;
    z-index: -1;
    transition: all 0.6s ease-out;
    top: 50%;
    width: 20px;
    height: 20px;
    border-radius: 0
}

.th-btn:before {
    left: -20px;
    transform: translate(-50%, -50%) rotate(45deg)
}

.th-btn:after {
    right: -20px;
    transform: translate(50%, -50%) rotate(45deg)
}

.th-btn .icon {
    overflow: hidden;
    display: inline-block
}

.th-btn .btn_arrow {
    transition: 0.4s all;
    position: relative;
    right: 2px
}

.th-btn:hover,
.th-btn.active {
    color: #fff;
    box-shadow: none
}

.th-btn:hover:before,
.th-btn.active:before {
    animation: criss-cross-left 0.9s both;
    animation-direction: alternate
}

.th-btn:hover:after,
.th-btn.active:after {
    animation: criss-cross-right 0.9s both;
    animation-direction: alternate
}

.th-btn:hover .btn_arrow,
.th-btn.active .btn_arrow {
    animation: btn-icon-anim 0.9s both;
    animation-direction: alternate
}

@keyframes criss-cross-left {
    0% {
        left: -20px
    }

    50% {
        left: 50%;
        height: 20px;
        width: 20px
    }

    100% {
        left: 50%;
        height: calc(300px*1.5);
        width: calc(300px*1.5)
    }
}


@keyframes criss-cross-right {
    0% {
        right: -20px
    }

    50% {
        right: 50%;
        height: 20px;
        width: 20px
    }

    100% {
        right: 50%;
        height: calc(300px*1.5);
        width: calc(300px*1.5)
    }
}

@keyframes btn-icon-anim {
    0% {
        top: 0;
        right: 2px
    }

    25% {
        top: -10px;
        right: -10px
    }

    50% {
        top: 10px;
        opacity: 0;
        right: 17px
    }

    100% {
        top: 0;
        right: 2px;
        opacity: 1
    }
}



/* button css */

/* .banner .bannerImg {
    animation-name: unlimitedRound;
    animation-duration: 5s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
} */

/*  



@keyframes auto-fill {
    0% {
        width: calc(100% - 80px);
    }

    50% {
        width: calc(100% - 35%);
    }

    100% {
        width: calc(100% - 80px);
    }
}

@keyframes animate-bounceTop {
    0% {
        transform: translateY(-25%);
    }

    100% {
        transform: none;
    }
} */

/* services */
/* .services .slick-list {
    margin: 0 -10px;
}

.services .slick-slide>div {
    padding: 0 10px;
} */

/* services */

/* testimonial */
/* .testimonial .slick-list {
    margin: 0 -6px;
}

.testimonial .slick-slide>div {
    padding: 0 6px;
}

.testimonial .testimonialBtn .slick-current img {
    border: 4px solid #f38432;
} */

/* testimonial */

.testimonial .slick-current.slick-active .item {
    background-color: #fff;
    box-shadow: 0px 0px 15px 5px rgba(34, 34, 34, 0.09);
}

.events .slick-slide>div {
    line-height: 0;
}







/* .testimonial .slick-list {
    padding: 20px !important;
}

.testimonial .slick-list {
    margin: 0 -10px;
}

.testimonial .slick-slide>div {
    padding: 0 10px;
} */

@media screen and (min-width: 991px) {

    .testimonial .slick-slide,
    .testimonial .slick-slide[aria-hidden="true"]:not(.slick-cloned)~.slick-cloned[aria-hidden="true"] {
        transform: scale(0.8, 0.8);
        transition: transform 0.3s;
        opacity: 0.7;
    }

    .testimonial .slick-center,
    .testimonial .slick-slide[aria-hidden="true"]:not([tabindex="-1"])+.slick-cloned[aria-hidden="true"] {
        transform: scale(1, 1);
        opacity: 1;
    }
}



@media (max-width: 1199px) {
    section {
        padding-top: 70px;
        padding-bottom: 70px;
    }

    h1 {
        font-size: 38px;
    }

    h2 {
        font-size: 32px;
    }

    h3 {
        font-size: 28px;
    }

    h4 {
        font-size: 25px;
    }

}


@media (max-width: 768px) {
    h1 {
        font-size: 34px;
    }

    h2 {
        font-size: 28px;
    }

    h3 {
        font-size: 24px;
    }

    h4 {
        font-size: 22px;
    }

    h5 {
        font-size: 20px;
    }

    .container {
        padding-left: 15px;
        padding-right: 15px;
    }

    section {
        padding-top: 50px;
        padding-bottom: 50px;
    }

}

.ql-editor ul {
    list-style-type: disc;
    padding-left: 20px;
  }
  
  .ql-editor ol {
    list-style-type: decimal;
    padding-left: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;;;IAMI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IAKI,eAAe;AAHnB;;AAMA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,yDAAmD;IACnD,sCAAsC;IACtC,4BAA4B;IAC5B,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yDAAkD;IAClD,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI,uCAAuC;AAC3C;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,eAAe;AACf;;IAEI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IAEX,6BAA6B;IAC7B,QAAQ;IACR,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IAGX;AACJ;;AAEA;IACI,YAAY;IAGZ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IAEI,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAGI,qCAAqC;IAErC;AACJ;;AAEA;;IAGI,sCAAsC;IAEtC;AACJ;;AAEA;;IAGI,kCAAkC;IAElC;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,SAAS;QACT,YAAY;QACZ;IACJ;;IAEA;QACI,SAAS;QACT,uBAAuB;QACvB;IACJ;AACJ;;;AAGA;IACI;QACI;IACJ;;IAEA;QACI,UAAU;QACV,YAAY;QACZ;IACJ;;IAEA;QACI,UAAU;QACV,uBAAuB;QACvB;IACJ;AACJ;;AAEA;IACI;QACI,MAAM;QACN;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,SAAS;QACT,UAAU;QACV;IACJ;;IAEA;QACI,MAAM;QACN,UAAU;QACV;IACJ;AACJ;;;;AAIA,eAAe;;AAEf;;;;;GAKG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH,aAAa;AACb;;;;;;GAMG;;AAEH,aAAa;;AAEb,gBAAgB;AAChB;;;;;;;;;;GAUG;;AAEH,gBAAgB;;AAEhB;IACI,sBAAsB;IACtB,mDAAmD;AACvD;;AAEA;IACI,cAAc;AAClB;;;;;;;;AAQA;;;;;;;;;;GAUG;;AAEH;;IAEI;;QAEI,0BAA0B;QAC1B,0BAA0B;QAC1B,YAAY;IAChB;;IAEA;;QAEI,sBAAsB;QACtB,UAAU;IACd;AACJ;;;;AAIA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;AAEJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap');\n\nbody {\n    font-size: 18px;\n    font-family: \"Nunito Sans\", sans-serif;\n    color: #33345E;\n}\n\n* {\n    box-sizing: border-box;\n    margin: 0px;\n    padding: 0px;\n}\n\n.primary_bg {\n    background: #1253A7;\n}\n\n.secondary_bg {\n    background: #6A79FF;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-weight: 500;\n    margin-bottom: 20px;\n    line-height: normal;\n}\n\nh1 {\n    font-size: 50px;\n    font-weight: 700;\n}\n\nh2 {\n    font-size: 40px;\n    font-weight: 700;\n}\n\nh3 {\n    font-size: 30px;\n    font-weight: 700;\n}\n\nh4 {\n    font-size: 26px;\n}\n\nh5 {\n    font-size: 22px;\n}\n\nh5 {\n    font-size: 20px;\n}\n\np {\n    margin-bottom: 20px;\n}\n\na {\n    transition: 0.4s;\n}\n\n.container {\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 25px;\n    padding-right: 25px;\n    max-width: 1500px;\n}\n\n/* Distinguished Features */\n.dis-features-section {\n    background-position: left bottom, right top;\n}\n\nsection {\n    padding-top: 80px;\n    padding-bottom: 80px;\n}\n\nselect {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-image: url(assets/images/drop_arrow.svg);\n    background-position: right 15px center;\n    background-repeat: no-repeat;\n    background-size: 13px;\n    padding-right: 35px !important;\n}\n\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-results-button,\ninput[type=\"search\"]::-webkit-search-results-decoration {\n    display: none;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.list {\n    margin-bottom: 25px;\n}\n\n.list li {\n    background-image: url(\"./assets/images/check.png\");\n    background-repeat: no-repeat;\n    background-size: 20px;\n    padding-left: 28px;\n    margin-bottom: 12px;\n    background-position: left 2px;\n}\n\ninput[type=number] {\n    -moz-appearance: textfield;\n}\n\n@keyframes slide {\n    from {\n        background-position: 0 0;\n    }\n\n    to {\n        background-position: 1920px 0;\n    }\n}\n\n.heading_title {\n    max-width: 800px;\n    margin: auto;\n    margin-bottom: 50px;\n    text-align: center;\n}\n\n.businesses:nth-child(1) {\n    background-color: #e43d34;\n}\n\n.businesses:nth-child(2) {\n    background-color: #ff8071;\n}\n\n.businesses:nth-child(3) {\n    background-color: #f19e3e;\n}\n\n.businesses:nth-child(4) {\n    background-color: #f5d417;\n}\n\n.businesses:nth-child(5) {\n    background-color: #4ca12c;\n}\n\n.businesses:nth-child(6) {\n    background-color: #00916a;\n}\n\n.businesses:nth-child(7) {\n    background-color: #007d93;\n}\n\n.businesses:nth-child(8) {\n    background-color: #2362cb;\n}\n\n.businesses:nth-child(9) {\n    background-color: #263294;\n}\n\n.businesses:nth-child(10) {\n    background-color: #2b2261;\n}\n\n@keyframes unlimitedrotate {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n\n.dance3 {\n    animation: dance3 8s alternate infinite;\n}\n\n@keyframes dance3 {\n    0% {\n        transform: scale(0.9);\n    }\n\n    100% {\n        transform: scale(1);\n    }\n}\n\n/* button css */\n.th-btn:before,\n.th-btn:after {\n    content: \"\";\n    position: absolute;\n    background-color: #1036de;\n    z-index: -1;\n    -webkit-transition: all 0.6s ease-out;\n    transition: all 0.6s ease-out;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    border-radius: 0\n}\n\n.th-btn:before {\n    left: -20px;\n    -webkit-transform: translate(-50%, -50%) rotate(45deg);\n    -ms-transform: translate(-50%, -50%) rotate(45deg);\n    transform: translate(-50%, -50%) rotate(45deg)\n}\n\n.th-btn:after {\n    right: -20px;\n    -webkit-transform: translate(50%, -50%) rotate(45deg);\n    -ms-transform: translate(50%, -50%) rotate(45deg);\n    transform: translate(50%, -50%) rotate(45deg)\n}\n\n.th-btn .icon {\n    overflow: hidden;\n    display: inline-block\n}\n\n.th-btn .btn_arrow {\n    -webkit-transition: 0.4s all;\n    transition: 0.4s all;\n    position: relative;\n    right: 2px\n}\n\n.th-btn:hover,\n.th-btn.active {\n    color: #fff;\n    box-shadow: none\n}\n\n.th-btn:hover:before,\n.th-btn.active:before {\n    -webkit-animation: criss-cross-left 0.9s both;\n    animation: criss-cross-left 0.9s both;\n    -webkit-animation-direction: alternate;\n    animation-direction: alternate\n}\n\n.th-btn:hover:after,\n.th-btn.active:after {\n    -webkit-animation: criss-cross-right 0.9s both;\n    animation: criss-cross-right 0.9s both;\n    -webkit-animation-direction: alternate;\n    animation-direction: alternate\n}\n\n.th-btn:hover .btn_arrow,\n.th-btn.active .btn_arrow {\n    -webkit-animation: btn-icon-anim 0.9s both;\n    animation: btn-icon-anim 0.9s both;\n    -webkit-animation-direction: alternate;\n    animation-direction: alternate\n}\n\n@keyframes criss-cross-left {\n    0% {\n        left: -20px\n    }\n\n    50% {\n        left: 50%;\n        height: 20px;\n        width: 20px\n    }\n\n    100% {\n        left: 50%;\n        height: calc(300px*1.5);\n        width: calc(300px*1.5)\n    }\n}\n\n\n@keyframes criss-cross-right {\n    0% {\n        right: -20px\n    }\n\n    50% {\n        right: 50%;\n        height: 20px;\n        width: 20px\n    }\n\n    100% {\n        right: 50%;\n        height: calc(300px*1.5);\n        width: calc(300px*1.5)\n    }\n}\n\n@keyframes btn-icon-anim {\n    0% {\n        top: 0;\n        right: 2px\n    }\n\n    25% {\n        top: -10px;\n        right: -10px\n    }\n\n    50% {\n        top: 10px;\n        opacity: 0;\n        right: 17px\n    }\n\n    100% {\n        top: 0;\n        right: 2px;\n        opacity: 1\n    }\n}\n\n\n\n/* button css */\n\n/* .banner .bannerImg {\n    animation-name: unlimitedRound;\n    animation-duration: 5s;\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n} */\n\n/*  \n\n\n\n@keyframes auto-fill {\n    0% {\n        width: calc(100% - 80px);\n    }\n\n    50% {\n        width: calc(100% - 35%);\n    }\n\n    100% {\n        width: calc(100% - 80px);\n    }\n}\n\n@keyframes animate-bounceTop {\n    0% {\n        transform: translateY(-25%);\n    }\n\n    100% {\n        transform: none;\n    }\n} */\n\n/* services */\n/* .services .slick-list {\n    margin: 0 -10px;\n}\n\n.services .slick-slide>div {\n    padding: 0 10px;\n} */\n\n/* services */\n\n/* testimonial */\n/* .testimonial .slick-list {\n    margin: 0 -6px;\n}\n\n.testimonial .slick-slide>div {\n    padding: 0 6px;\n}\n\n.testimonial .testimonialBtn .slick-current img {\n    border: 4px solid #f38432;\n} */\n\n/* testimonial */\n\n.testimonial .slick-current.slick-active .item {\n    background-color: #fff;\n    box-shadow: 0px 0px 15px 5px rgba(34, 34, 34, 0.09);\n}\n\n.events .slick-slide>div {\n    line-height: 0;\n}\n\n\n\n\n\n\n\n/* .testimonial .slick-list {\n    padding: 20px !important;\n}\n\n.testimonial .slick-list {\n    margin: 0 -10px;\n}\n\n.testimonial .slick-slide>div {\n    padding: 0 10px;\n} */\n\n@media screen and (min-width: 991px) {\n\n    .testimonial .slick-slide,\n    .testimonial .slick-slide[aria-hidden=\"true\"]:not(.slick-cloned)~.slick-cloned[aria-hidden=\"true\"] {\n        transform: scale(0.8, 0.8);\n        transition: transform 0.3s;\n        opacity: 0.7;\n    }\n\n    .testimonial .slick-center,\n    .testimonial .slick-slide[aria-hidden=\"true\"]:not([tabindex=\"-1\"])+.slick-cloned[aria-hidden=\"true\"] {\n        transform: scale(1, 1);\n        opacity: 1;\n    }\n}\n\n\n\n@media (max-width: 1199px) {\n    section {\n        padding-top: 70px;\n        padding-bottom: 70px;\n    }\n\n    h1 {\n        font-size: 38px;\n    }\n\n    h2 {\n        font-size: 32px;\n    }\n\n    h3 {\n        font-size: 28px;\n    }\n\n    h4 {\n        font-size: 25px;\n    }\n\n}\n\n\n@media (max-width: 768px) {\n    h1 {\n        font-size: 34px;\n    }\n\n    h2 {\n        font-size: 28px;\n    }\n\n    h3 {\n        font-size: 24px;\n    }\n\n    h4 {\n        font-size: 22px;\n    }\n\n    h5 {\n        font-size: 20px;\n    }\n\n    .container {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n\n    section {\n        padding-top: 50px;\n        padding-bottom: 50px;\n    }\n\n}\n\n.ql-editor ul {\n    list-style-type: disc;\n    padding-left: 20px;\n  }\n  \n  .ql-editor ol {\n    list-style-type: decimal;\n    padding-left: 20px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
